import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: true,
    imports: [FlexModule, MatButtonModule, RouterLink]
})
//** *Page Not Found Component */
export class PageNotFoundComponent implements OnInit {
	constructor() {}
	ngOnInit(): void {}
}
